export class SwapReason {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
}

export default SwapReason;